import { Chip, SxProps } from "@mui/material";

interface MergedWasteStreamChipProps {
  mergeCount: number;
  sx?: SxProps;
}

export const MergedWasteStreamChip = ({
  mergeCount,
  sx,
}: MergedWasteStreamChipProps) => {
  // Don't render chip if not merged (mergeCount <= 1)
  if (mergeCount <= 1) {
    return null;
  }

  return (
    <Chip
      label={`Merged (${mergeCount})`}
      size="small"
      variant="filled"
      color="default"
      sx={sx}
    />
  );
};
